import _slicedToArray from "/var/lib/jenkins/workspace/mr-learner-frontend-production/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import { generateColor } from '../util';
import ColorSteppers from './ColorSteppers';

var ColorRgbInput = function ColorRgbInput(_ref) {
  var prefixCls = _ref.prefixCls,
      value = _ref.value,
      onChange = _ref.onChange;
  var colorRgbInputPrefixCls = "".concat(prefixCls, "-rgb-input");

  var _useState = useState(generateColor(value || '#000')),
      _useState2 = _slicedToArray(_useState, 2),
      rgbValue = _useState2[0],
      setRgbValue = _useState2[1]; // Update step value


  useEffect(function () {
    if (value) {
      setRgbValue(value);
    }
  }, [value]);

  var handleRgbChange = function handleRgbChange(step, type) {
    var rgb = rgbValue.toRgb();
    rgb[type] = step || 0;
    var genColor = generateColor(rgb);

    if (!value) {
      setRgbValue(genColor);
    }

    onChange === null || onChange === void 0 ? void 0 : onChange(genColor);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: colorRgbInputPrefixCls
  }, /*#__PURE__*/React.createElement(ColorSteppers, {
    max: 255,
    min: 0,
    value: Number(rgbValue.toRgb().r),
    prefixCls: prefixCls,
    className: colorRgbInputPrefixCls,
    onChange: function onChange(step) {
      return handleRgbChange(Number(step), 'r');
    }
  }), /*#__PURE__*/React.createElement(ColorSteppers, {
    max: 255,
    min: 0,
    value: Number(rgbValue.toRgb().g),
    prefixCls: prefixCls,
    className: colorRgbInputPrefixCls,
    onChange: function onChange(step) {
      return handleRgbChange(Number(step), 'g');
    }
  }), /*#__PURE__*/React.createElement(ColorSteppers, {
    max: 255,
    min: 0,
    value: Number(rgbValue.toRgb().b),
    prefixCls: prefixCls,
    className: colorRgbInputPrefixCls,
    onChange: function onChange(step) {
      return handleRgbChange(Number(step), 'b');
    }
  }));
};

export default ColorRgbInput;